(function() {
'use strict';

angular
    .module('MW.ContactManager.BeatsSelectAccordion',[
        'MW.Framework.TranslationService',
        'MW.Framework.orderByDiacritics'
    ])
    .directive('beatsSelectAccordion', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/beats_select_accordion',
            scope: {
                options: '=',
                displayState: '=',
                loadingState: '@'
            },
            controller: BeatsSelectAccordionController,
            controllerAs: 'beatsController',
            bindToController: true
        };
    })
    .controller('BeatsSelectAccordionController', [
        '$scope',
        '$filter',
        'translationService',
        BeatsSelectAccordionController
    ]);

    function BeatsSelectAccordionController ($scope, $filter, translationService) {
        var unbindOptionsWatch;

        this.$filter = $filter;

        this.openAccordion = false;
        this.searchText = '';
        this.summaryExpanded = false;
        this.MAX_TAGS_TO_SHOW = 5;
        this.moreItem = '';
        this.LESS_ITEMS_STRING = translationService.getLocalizedString('Less items');
        this.ONE_MORE_ITEM_STRING = translationService.getLocalizedString('1 more item');

        this.currentOptions = [];

        this.history = [];
        this.parent = null;

        this.translationService = translationService;

        this.filteredOptions = [];
        unbindOptionsWatch = $scope.$watch('beatsController.options', function (newVal) {
            if(Array.isArray(newVal) && newVal.length) {
                var orderedOptions = this._orderItems(newVal);

                this.currentOptions = orderedOptions;
                this.filteredOptions = orderedOptions;

                unbindOptionsWatch();
            }
        }.bind(this));

        $scope.$watch('beatsController.searchText', function () {
            this._filterOptions();
        }.bind(this));
    }

    BeatsSelectAccordionController.prototype._orderItems = function _orderItems(items) {
        return this.$filter('orderByDiacritics')(items, 'name');
    };

    BeatsSelectAccordionController.prototype._filterOptions = function _filterOptions() {
        var searchText = this.searchText;

        this.filteredOptions = this.$filter('filter')(this.currentOptions, _nameMatchPredicate);
        this.filteredCounts = {};

        if(searchText && this.filteredOptions.length) {
            this.filteredOptions.forEach(function(option) {
                if(option.children) {
                    var count = this.$filter('filter')(option.children, {name: searchText}).length,
                        matchString = (count > 1) ? ' matches' : ' match';

                    if(count > 0) {
                        this.translationService.getLocalizedString([[count]] + matchString, {count: count}, true).then(function(translatedString){
                            this.filteredCounts[option.id] = translatedString;
                        }.bind(this));
                    }
                }
            }, this);
        }

        function _nameMatchPredicate (element) {
            var foundMatch = false;

            if(element && element.name && element.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
                foundMatch = true;
            } else if (element.children){
                foundMatch = element.children.some(function (child) {
                    return child.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
                });
            }

            return foundMatch;
        }
    };

    BeatsSelectAccordionController.prototype.toggleAccordion = function toggleAccordion () {
        this.openAccordion = !this.openAccordion;
    };

    BeatsSelectAccordionController.prototype.openChild = function openChild (option) {
        this.history.push({
            options: this.currentOptions,
            parent: this.parent
        });

        this.currentOptions = this._orderItems(option.children);
        this.parent = option;

        // check if the page is fully selected
        this.displayState.allSelected = this.isPageFullySelected();
        this._filterOptions();
    };

    BeatsSelectAccordionController.prototype.openParent = function openParent () {
        var historyObject = this.history.pop();

        // before drilling back up, check children
        // if all children are selected, remove their selections & select the parent
        // if page is partially selected, partially select parent
        if(this.isPageFullySelected()) {
            this.select(this.parent);

            this.currentOptions.forEach(function(currentOption) {
                this.deselect(currentOption);
            }, this);
        } else if (this.isPagePartiallySelected()) {
            this.partiallySelect(this.parent);
        }

        this.currentOptions = this._orderItems(historyObject.options);
        this.parent = historyObject.parent;

        // after drilling up, check if everything at this level is selected
        this.displayState.allSelected = this.isPageFullySelected();
        this._filterOptions();

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype._deselectChildren = function _deselectChildren(parentBeat) {
        if(Array.isArray(parentBeat.children) && parentBeat.children.length) {
            parentBeat.children.forEach(function(child) {
                this.deselect(child);
            }, this);
        }
    };

    BeatsSelectAccordionController.prototype.toggle = function toggle (option) {
        // if the parent was selected & we toggle a child, we want to deslect select the parent
        // the parents new state will be determined when we go back up a level (openParent method)
        if(this.parent && this.isSelected(this.parent)) {
            this.deselect(this.parent);
        }

        if(this.isSelected(option)) {
            this.deselect(option);
            this.displayState.allSelected = false;
        } else {
            this.select(option);
            this.displayState.allSelected = this.isPageFullySelected();

            // when selecting an option with children, we need to deslect them
            this._deselectChildren(option);
        }

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype.select = function select(option) {
        if(this.isPartiallySelected(option)) {
            this.removePartialSelection(option);
        }

        this.displayState.selected[option.id] = option;
    };

    BeatsSelectAccordionController.prototype.deselect = function deselect(option) {
        if(this.isPartiallySelected(option)) {
            this.removePartialSelection(option);
        }

        this._removeSelection(option);
    };

    BeatsSelectAccordionController.prototype._removeSelection = function _removeSelection(option) {
        delete this.displayState.selected[option.id];
    };

    BeatsSelectAccordionController.prototype.summaryDeselect = function summaryDeselect(option) {
        var i,
            parentObject;

        // when we deselect from the summary, we could be at any level of options
        // we need to then determine what to do with any parent/children
        this.deselect(option);

        // if the option has a parent...
        if(option.parentId) {
            // note: this will only work for options with 2 levels
            for(i = 0; i < this.options.length; i++) {
                if(this.options[i].id === option.parentId) {
                    parentObject = this.options[i];
                    break;
                }
            }

            // if the parent is fully selected & we deselected a child, partially select parent
            // if the parent is partially selected & we deslect a child, we need to determine now if it is fully deselected or still partially selected
            if(this.isSelected(parentObject)) {
                this.partiallySelect(parentObject);
            } else if(this.isPartiallySelected(parentObject)) {
                var allChildrenUnselected = parentObject.children.every(function(child) {
                    return !this.isSelected(child);
                }, this);

                if(allChildrenUnselected) {
                    this.removePartialSelection(parentObject);
                }
            }
        }

        // if the option has children - we need to deselect them all, since we deselected the parent
        if(option.children.length) {
            option.children.forEach(function(child) {
                if(this.isSelected(child)) {
                    this.deselect(child);
                }
            }, this);
        }

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype.partiallySelect = function partiallySelect(option) {
        if(this.isSelected(option)) {
            this.deselect(option);
        }

        this.displayState.partiallySelected[option.id] = option;
    };

    BeatsSelectAccordionController.prototype.removePartialSelection = function removePartialSelection(option) {
        delete this.displayState.partiallySelected[option.id];
    };

    BeatsSelectAccordionController.prototype.toggleAllCurrent = function toggleAllCurrent () {
        // if the parent was selected & we toggle current page, we want to deslect select the parent
        // the parents new state will be determined when we go back up a level (openParent method)
        if(this.parent && this.isSelected(this.parent)) {
            this.deselect(this.parent);
        }

        if(this.isPageFullySelected()) {
            this.currentOptions.forEach(function(currentOption) {
                if(this.isSelected(currentOption)) {
                    this.deselect(currentOption);
                }
            }, this);

            this.displayState.allSelected = false;
        } else {
            this.currentOptions.forEach(function(currentOption) {
                if(!this.isSelected(currentOption)) {
                    this.select(currentOption);

                    this._deselectChildren(currentOption);
                }
            }, this);

            this.displayState.allSelected = true;
        }

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype.isSelected = function isSelected(option) {
        return !!this.displayState.selected[option.id];
    };

    BeatsSelectAccordionController.prototype.isPartiallySelected = function isPartiallySelected(option) {
        return !!this.displayState.partiallySelected[option.id];
    };

    BeatsSelectAccordionController.prototype.isPageFullySelected = function isPageFullySelected() {
        if(!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return false;
        }

        return this.currentOptions.every(function(currentOption) {
            return this.isSelected(currentOption);
        }, this);
    };

    BeatsSelectAccordionController.prototype.isPageFullyDeselected = function isPageFullyDeselected() {
        if(!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return true;
        }

        return this.currentOptions.every(function(currentOption) {
            return !this.isSelected(currentOption);
        }, this);
    };

    BeatsSelectAccordionController.prototype.isPagePartiallySelected = function isPagePartiallySelected() {
        var selectedCount = 0;

        if(!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return false;
        }

        this.currentOptions.forEach(function(currentOption) {
            if(this.isSelected(currentOption)) {
                selectedCount++;
            }
        }, this);

        return ((selectedCount > 0) && (selectedCount < this.currentOptions.length));
    };

    BeatsSelectAccordionController.prototype._updateSummaryState = function _updateSummaryState() {
        if (this.summaryExpanded && this._getSelectedCount() <= this.MAX_TAGS_TO_SHOW) {
            this.summaryExpanded = false;
        }
        this.moreItem = this._getHiddenText();
    };

    BeatsSelectAccordionController.prototype._getSelectedCount = function _getSelectedCount () {
        return Object.keys(this.displayState.selected).length;
    };

    BeatsSelectAccordionController.prototype._getHiddenText = function _getHiddenText() {
        var hiddenText = '',
            numberOfHiddenTags = this._getSelectedCount() - this.MAX_TAGS_TO_SHOW;

        if (this.summaryExpanded) {
            hiddenText = this.LESS_ITEMS_STRING;
        } else {
            if (numberOfHiddenTags === 1) {
                hiddenText = this.ONE_MORE_ITEM_STRING;
            }
            else if (numberOfHiddenTags > 1) {
                hiddenText = this.translationService.getLocalizedString('[[itemCount]] more items', {itemCount: numberOfHiddenTags});
            }
        }

        return hiddenText;
    };
}());
